import { useQuery } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

export function useUpcomingEvents({ from, to }) {
  const scopeKey = useScopeKey();
  const enabled = !!(from && to) && scopeKey !== 'loading';
  return useQuery({
    queryKey: ['upcoming-events', scopeKey, { from, to }],
    queryFn: () => api.get(`/upcoming-events?from=${from}&to=${to}`),
    staleTime: 60_000,
    enabled,
  });
}
